import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito tener experiencia en pastelería para usar este pack?',
    answer: 'Para nada. El Mega Pack fue diseñado específicamente para personas sin experiencia. Todo está explicado paso a paso, con lenguaje simple y sin términos técnicos.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: '100% digital. Apenas confirmás el pago, recibís un mail con el link de descarga de todos los PDFs. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    question: '¿Los ingredientes se consiguen en Argentina?',
    answer: 'Sí. Todas las recetas están pensadas con ingredientes que se consiguen en cualquier supermercado o dietética de Argentina.'
  }, {
    question: '¿Sirve si vivo en el interior del país?',
    answer: 'Sí. El Tomo 6 incluye estrategias de venta adaptadas para todo el país: WhatsApp, Instagram, ferias locales y delivery.'
  }, {
    question: '¿Tiene garantía real?',
    answer: 'Sí. 7 días de garantía total. Si no estás conforme, te devolvemos el 100% sin hacer preguntas.'
  }];
  return <section className="w-full bg-[#FAF0DE] py-4 md:py-8" data-id="element-56">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3D2817] text-center mb-3 md:mb-6" data-id="element-59">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>

          <div className="space-y-2" data-id="element-60">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="bg-white border border-[#E8D5BA] rounded-lg overflow-hidden shadow-sm" data-id="element-61">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left hover:bg-[#FAF1E4] transition-colors" data-id="element-62">
                  <span className="text-base font-semibold text-[#3D2817] pr-4" data-id="element-63">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-[#B45309] flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-64" />
                </button>
                <AnimatePresence data-id="element-65">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-66">
                      <div className="px-4 pb-4 text-[#6B5747] text-sm leading-relaxed" data-id="element-67">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}